import type { Template } from "@/types";

export const LA_04_H2_V2: Template[] = [
    {
        id: "la-04-h2v2-01",
        name: "LA 01 - H2V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-04-h2_v2_01.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 41, y: 125, width: 179, height: 283, rotation: 0, imageRotation: 0 },
            { id: "2", x: 228, y: 125, width: 404, height: 283, rotation: 0, imageRotation: 0 },
            { id: "3", x: 720, y: 125, width: 404, height: 283, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1132, y: 125, width: 179, height: 283, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h2v2-02",
        name: "LA 02 - H2V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-04-h2_v2_02.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 43, y: 116, width: 191, height: 301, rotation: 0, imageRotation: 0 },
            { id: "2", x: 241, y: 116, width: 432, height: 301, rotation: 0, imageRotation: 0 },
            { id: "3", x: 681, y: 116, width: 431, height: 301, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1119, y: 116, width: 191, height: 301, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h2v2-03",
        name: "LA 03 - H2V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-04-h2_v2_03.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 0, y: 104, width: 203, height: 322, rotation: 0, imageRotation: 0 },
            { id: "2", x: 210, y: 104, width: 462, height: 322, rotation: 0, imageRotation: 0 },
            { id: "3", x: 680, y: 104, width: 461, height: 322, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1148, y: 104, width: 203, height: 322, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h2v2-04",
        name: "LA 04 - H2V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-04-h2_v2_04.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 43, y: 164, width: 291, height: 203, rotation: 0, imageRotation: 0 },
            { id: "2", x: 342, y: 164, width: 290, height: 203, rotation: 0, imageRotation: 0 },
            { id: "3", x: 714, y: 36, width: 291, height: 458, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1013, y: 36, width: 290, height: 458, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h2v2-05",
        name: "LA 05 - H2V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-04-h2_v2_05.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 189, y: 51, width: 298, height: 429, rotation: 0, imageRotation: 0 },
            { id: "2", x: 800, y: 52, width: 429, height: 228, rotation: 0, imageRotation: 0 },
            { id: "3", x: 800, y: 287, width: 285, height: 192, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1092, y: 287, width: 138, height: 192, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h2v2-06",
        name: "LA 06 - H2V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-04-h2_v2_06.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 171, y: 57, width: 334, height: 205, rotation: 0, imageRotation: 0 },
            { id: "2", x: 171, y: 270, width: 334, height: 205, rotation: 0, imageRotation: 0 },
            { id: "3", x: 743, y: 56, width: 268, height: 419, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1018, y: 56, width: 268, height: 419, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h2v2-07",
        name: "LA 07 - H2V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-04-h2_v2_07.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 176, y: 49, width: 323, height: 203, rotation: 0, imageRotation: 0 },
            { id: "2", x: 176, y: 260, width: 158, height: 221, rotation: 0, imageRotation: 0 },
            { id: "3", x: 342, y: 260, width: 158, height: 221, rotation: 0, imageRotation: 0 },
            { id: "4", x: 743, y: 83, width: 543, height: 363, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h2v2-08",
        name: "LA 08 - H2V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-04-h2_v2_08.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 45, y: 66, width: 563, height: 398, rotation: 0, imageRotation: 0 },
            { id: "2", x: 615, y: 66, width: 123, height: 195, rotation: 0, imageRotation: 0 },
            { id: "3", x: 615, y: 268, width: 123, height: 195, rotation: 0, imageRotation: 0 },
            { id: "4", x: 745, y: 66, width: 563, height: 398, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h2v2-09",
        name: "LA 09 - H2V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-04-h2_v2_09.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 40, y: 36, width: 289, height: 458, rotation: 0, imageRotation: 0 },
            { id: "2", x: 336, y: 133, width: 337, height: 265, rotation: 0, imageRotation: 0 },
            { id: "3", x: 680, y: 133, width: 337, height: 265, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1024, y: 36, width: 289, height: 458, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h2v2-10",
        name: "LA 10 - H2V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-04-h2_v2_10.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 82, y: 70, width: 140, height: 192, rotation: 0, imageRotation: 0 },
            { id: "2", x: 82, y: 269, width: 140, height: 191, rotation: 0, imageRotation: 0 },
            { id: "3", x: 228, y: 70, width: 517, height: 392, rotation: 0, imageRotation: 0 },
            { id: "4", x: 752, y: 70, width: 517, height: 392, rotation: 0, imageRotation: 0 }
        ],
    }
];